@if (visible()) {
  <aside
    class="cookie-notice"
    [class.cookie-notice--expanded]="expanded()"
    aria-label="Уведомление об использовании cookie"
  >
    <div class="cookie-notice-main">
      <div class="cookie-notice-info">
        <span class="cookie-notice-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" focusable="false">
            <path
              d="M20.5 13a8.5 8.5 0 1 1-9.5-9.5 3 3 0 0 0 3 3 3 3 0 0 0 3 3 3 3 0 0 0 3 3 3 3 0 0 0 2.5.5Z"
            />
            <circle cx="8" cy="12" r=".8" />
            <circle cx="12" cy="16" r=".8" />
            <circle cx="7" cy="8" r=".8" />
          </svg>
        </span>

        <div class="cookie-notice-copy">
          <p class="cookie-notice-summary">
            Данный веб-сайт использует cookie-файлы в целях предоставления вам лучшего
            пользовательского опыта на нашем сайте. Продолжая использовать данный сайт, вы
            соглашаетесь с использованием нами cookie-файлов. Для получения дополнительной
            информации см.
            <a class="cookie-notice-policy-inline" routerLink="/privacy">Политика Cookie</a>.
          </p>
        </div>
      </div>

      <button class="cookie-notice-accept" type="button" (click)="accept()">Принять</button>
    </div>

    <div class="cookie-notice-data">
      <div class="cookie-notice-data-copy">
        <h3 class="cookie-notice-data-title">Об использовании данных</h3>
        <p class="cookie-notice-data-summary">
          Используем технические данные оборудования для работы сервиса и персонализации
          предложений.
        </p>
      </div>

      <button
        class="cookie-notice-details-button"
        type="button"
        aria-controls="cookie-notice-details"
        [attr.aria-expanded]="expanded()"
        (click)="toggleDetails()"
      >
        {{ expanded() ? 'Свернуть' : 'Подробнее' }}
      </button>
    </div>

    <div
      class="cookie-notice-details"
      id="cookie-notice-details"
      role="region"
      aria-label="Подробная информация об использовании cookie и данных"
      [hidden]="!expanded()"
    >
      <p class="cookie-notice-text">
        Уведомляем, что ваше оборудование может передавать данные, которые можно сохранить и
        обезличенно сопоставить с иными публичными данными в интернете. Отключение данных вашего
        оборудования находится в сфере вашего контроля, и мы исходим из того, что продолжая
        пользоваться нашим сервисом вы произвели все необходимые настройки и только после этих
        настроек передаете нам данные оборудования для их обработки без сопоставления с
        персональными данными, что означает Ваше согласие на их дальнейшую, в том числе
        обезличенную, обработку, после которой вы или иной пользователь вашего оборудования можете
        получить персонализированное и уникальное торговое предложение. Пользуясь нашим сервисом вы
        совершаете действия в публичном интернет-пространстве и согласны с передачей данных
        оборудования для их хранения без сопоставления с персональными данными, как они понимаются в
        законодательстве Российской Федерации, и для их сопоставления с открытыми данными, либо с
        данными, которые предоставлены прежде вашим оборудованием, либо Вами, на иных сервисах. Если
        вы считаете, что не настроили оборудование для использования в публичном
        интернет-пространстве в соответствии с вашими интересами, не пользуйтесь нашим сервисом,
        поскольку его использование вами мы расцениваем как добровольное информированное согласие на
        действия, перечисленные выше, и подтверждение вами этого согласия через оборудование,
        которое вы используете.
      </p>
    </div>
  </aside>
}
